var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"afk-list-item__icon-container",style:(_vm.backgroundColor),attrs:{"data-testid":"afk-list-item__icon-container"}},[_c('img',{staticClass:"afk-list-item__icon",attrs:{"data-testid":"afk-list-item__icon","src":_vm.icon,"alt":_vm.examination,"title":_vm.examination}})])
}
var staticRenderFns = []

export { render, staticRenderFns }